import { render, staticRenderFns } from "./IBPT.vue?vue&type=template&id=6390516e"
import script from "./IBPT.vue?vue&type=script&lang=js"
export * from "./IBPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports